import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PageRequest, PaginationPage } from 'src/app/common/modules/data-table.module';
import { DoctorPatient } from 'src/app/entities/doctor-patient.entity/doctor-patient';
import { User, EUserRole } from 'src/app/entities/user.entity';
import { Doctor } from 'src/app/entities/user.entity/doctor.entity';
import { AuthService } from 'src/app/services/auth.service/auth.service';
import { DoctorPatientsService } from 'src/app/services/doctor-patients.service/doctor-patients.service';
import { DoctorSecretaryPatientsService } from 'src/app/services/doctor-secretary-appointments.service/doctor-secretary-patients.service/doctor-secretary-patients.service';

@Component({
  selector: 'app-doctor-patients-table-sortbal',
  templateUrl: './doctor-patients-table-sortbal.component.html',
  styleUrls: ['./doctor-patients-table-sortbal.component.css']
})
export class DoctorPatientsTableSortbalComponent implements OnInit {
  @Input() headers: Array<{ label: string, sorted?: { key: string, order: number } }> = [{ label: 'Dossier N° ' }, { label: 'Patient' }, { label: 'Téléphone' }, { label: 'Date Naissance' }, { label: 'Ville' }, { label: 'Accompagnant' }, { label: 'Rdv' }]
isOpen:boolean=false
  @Input() currentPage: number = 0;
  @Input() perPage: number = 10;
  @Input() pageRequest!: (pageRequest: PageRequest) => Promise<PaginationPage<DoctorPatient>>;
  @Output() onAssignAppointmentRequest: EventEmitter<DoctorPatient> = new EventEmitter();
  @Output() onAntecedentsRequest: EventEmitter<DoctorPatient> = new EventEmitter();
  @Output() onUpdateRequest: EventEmitter<DoctorPatient> = new EventEmitter();
  @Output() onDeleteRequest: EventEmitter<DoctorPatient> = new EventEmitter();
  @Output() onPrescriptionsRequest: EventEmitter<DoctorPatient> = new EventEmitter();
  @Output() onConsultationsRequest: EventEmitter<DoctorPatient> = new EventEmitter();
  @Output() onAssignAppointmentMultipleRequest: EventEmitter<DoctorPatient> = new EventEmitter();
  @Output() onPatientVaccinRequest: EventEmitter<DoctorPatient> = new EventEmitter();

  @Output() onRefresh: EventEmitter<PageRequest> = new EventEmitter();

  @Input() actions: Partial<{ edit: boolean, delete: boolean, assignAppointment: boolean, prescriptionsView: boolean, consultationsView: boolean, antecentendsView: boolean, payementsView: boolean, badge: boolean,assginAppointmentMultiple:boolean,patientVaccin:boolean }> = {}
  @Input() emptyMessage?: string;

  date: number = (new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())).getTime();
  doctorPatients: Array<DoctorPatient> = new Array();


  sortedheadIndex: number = -1;


  get hasActions(): boolean { return Object.values(this.actions).some(e => e == true) }
  constructor(private doctorPatientsService: DoctorPatientsService, private doctorSecretaryPatientsService: DoctorSecretaryPatientsService, private authService: AuthService, private toasterService: ToastrService) { }

  get currentUser(): User {
    return this.authService.getCurrentUser()!;
  }

  ngOnInit(): void {
    this.currentPage = 0;
  }
  public isTextLong(text: string, limit: number): boolean {
    return text.length > limit;
  }
  onSortRequested(headIndex: number, key: string): void {
    if (headIndex == this.sortedheadIndex) {
      this.sortedheadIndex = -1;
      this.onRefresh.emit()
    } else {
      this.sortedheadIndex = headIndex;

    }
  }
  get doctor():Doctor{
    return new Doctor(this.authService.getCurrentUser() !)
  }
  toggleDropdown() {
  this.isOpen = !this.isOpen;

  const tableResponsive = document.querySelector('.table-responsive');
  if (tableResponsive) {
    if (this.isOpen) {
      tableResponsive.classList.add('show-dropdown');
    } else {
      tableResponsive.classList.remove('show-dropdown');
    }
  }
}
  onDelete(doctorPatient: DoctorPatient): void {
    if (confirm(`Etez vous sure de vouloir supprimer ${doctorPatient.getFullName()} de votre liste des patients ?`))
      (this.currentUser.role == EUserRole.DOCTOR_SECRETARY ? this.doctorSecretaryPatientsService : this.doctorPatientsService).delete(doctorPatient.id).subscribe(deletetion => {
        this.toasterService.success(`patient ${doctorPatient.getFullName()} Supprimé`);
        this.onRefresh.emit({ pageOffset: 0, pageSize: 10 })
      }, error => {
        if (error.status === 501)
          this.toasterService.warning('Patient à des consultations ou bien des prescriptions')
        else
          this.toasterService.error(`Problème de suppression patient`);
      })

  }

}
